const history = {
  table: {
    headers: {
      createdBy: 'By',
      createdAt: 'Created At',
      updatedAt: 'Last Updated',
      updatedBy: 'By',
      oldValue: 'Old Value',
      newValue: 'New Value',
      date: 'Date',
      beforeCopy: {
        regular: 'Copy',
        sessionId: 'Copy Session ID',
      },
      afterCopy: 'Copied',
      field: 'Field',
      description: 'Description',
      by: 'By',
    },
  },
};

export default history;
